// extracted by mini-css-extract-plugin
export default {"page":"TrainerChatsLayout_page__8Jzlc","inner":"TrainerChatsLayout_inner__jvNNU","content":"TrainerChatsLayout_content__zMMEV"};